<template>
  <div class="invalid-elements-wrapper">
    <div class="invalid-element"
      v-for="(err, key) in error_list"
      :key="key"
    >
      {{ err }}
    </div>
  </div>
</template>

<script>
export default {
    props:['error_list'],
}
</script>